<template>
	<b-modal
		id="modal-relogin"
		:title="'Your session has timed out. Please sign in again.'"
		no-close-on-esc
		no-close-on-backdrop
	>
		<div>
			<b-form @submit.prevent="onLoginSubmit">
				<b-form-group id="input-group-1" label-for="input-1">
					<b-form-input
						id="username"
						type="email"
						disabled
						:value="email"
						placeholder="acme@email.com"
					></b-form-input>
					<b-form-input
						id="password"
						type="password"
						v-model="loginForm.password"
						placeholder="********"
					></b-form-input>
					<b-form-text v-if="$v.loginForm.password.$error">
						Please enter your password
					</b-form-text>
				</b-form-group>
				<b-button
					type="submit"
					variant="primary"
					:class="[{ disabled: lock === true }]"
					>Login <b-spinner :class="['ml-1']" small v-if="lock"></b-spinner
				></b-button>
				<div class="form-error" v-if="errorMessage">
					{{ errorMessage }}
				</div>
			</b-form>
		</div>
	</b-modal>
</template>

<script>
import { required, minLength, between } from "vuelidate/lib/validators";
import { XIcon } from "vue-feather-icons";
export default {
	components: {
		XIcon,
	},
	data: function() {
		var obj = {
			lock: false,
			key: "",
			errorMessage: "",
			loginForm: {
				password: "12345678",
			},
			tabIndex: 1,
		};
		return obj;
	},
	validations: {
		loginForm: {
			password: {
				required,
				minLength: minLength(3),
			},
		},
	},
	computed: {
		email: function() {
			let user = this.$store.getters["user/user"];
			if (user) {
				return user.email;
			} else {
				return false;
			}
		},
	},
	methods: {
		onLoginSubmit: function() {
			this.$v.$touch();
			if (!this.$v.$invalid) {
				this.submitLogin();
			}
		},
		submitLogin: function() {
			this.lock = true;
			let form = this.loginForm;
			form.username = this.email;
			this.$store
				.dispatch("user/login", this.loginForm)
				.then((res) => {
					this.$bvModal.hide("modal-relogin");
					this.errorMessage = "";
					this.lock = false;
				})
				.catch((err) => {
					this.$bvModal.hide("modal-relogin");
					this.$store.dispatch("user/logout");
					this.errorMessage =
						"No user with that email and password combination exists. Please enter re-enter your details";
					this.lock = false;
				});
		},
	},
	mounted: function() {},
};
</script>

<style lang="scss">
#modal-relogin___BV_modal_outer_ {
	.modal-dialog {
		max-width: 400px;
	}
}
</style>
